var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_399_2964)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1632 17.2567C15.4882 17.205 15.5523 16.58 16.189 16.4625C17.2465 16.2675 17.7115 15.7008 17.7115 15.1767C17.7115 14.7358 17.3815 14.325 16.7965 14.1925C16.099 14.035 16.2432 13.5617 16.8223 13.5158C17.7657 13.4408 18.229 12.8792 18.229 12.3408C18.229 11.87 17.8748 11.4175 17.1782 11.3242C16.464 11.2283 16.6965 10.7125 17.204 10.5558C17.6382 10.4225 18.3323 10.1392 18.3323 9.2975C18.3323 8.7375 17.9157 7.99583 16.4398 8.05583C15.4165 8.0975 13.384 7.89083 12.2907 7.31833C13.0465 4.27083 12.8648 0 10.8848 0C9.5565 0 9.30484 1.50583 8.90567 2.89083C7.474 7.865 4.609 8.77583 1.6665 9.22667V17.5C7.23984 17.5 8.74984 20 12.9207 20C15.5865 20 16.964 18.5542 16.964 17.7783C16.9632 17.5 16.7365 17.3017 16.1632 17.2567Z",
    fill: "#2CB852"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_399_2964"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.27d2be4ff7e98e82dfa55d08c2aaf62c.svg";
export { ForwardRef as ReactComponent };